export default __webpack_public_path__ + "static/media/central_andes_2_6.4c2fe24c.JPG";